/* eslint-disable react-hooks/rules-of-hooks */
import { useSelector } from 'react-redux';
import { selectEstimationTarget, selectIsNewbuilding } from '../../../selectors';
import { EMyHomeEstimationTargets } from '../../../types/estimationTarget';
import { useActions } from '../../../hooks';

export const getValidateAction = () => {
  const estimationTarget = useSelector(selectEstimationTarget);
  const isNewbuilding = useSelector(selectIsNewbuilding);

  const { validateFlatFormFields, validateHouseFormFilters, validateLandFormFilters, validateNewbuildingFormFields } =
    useActions();

  if (isNewbuilding) {
    return validateNewbuildingFormFields;
  }

  if (estimationTarget === EMyHomeEstimationTargets.house) {
    return validateHouseFormFilters;
  }

  if (estimationTarget === EMyHomeEstimationTargets.land) {
    return validateLandFormFilters;
  }

  return validateFlatFormFields;
};
